import { render, staticRenderFns } from "./RoomRequest.vue?vue&type=template&id=70372dad&scoped=true&"
import script from "./RoomRequest.vue?vue&type=script&lang=ts&"
export * from "./RoomRequest.vue?vue&type=script&lang=ts&"
import style0 from "./RoomRequest.vue?vue&type=style&index=0&id=70372dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70372dad",
  null
  
)

export default component.exports